import React from "react"
import  { AppImagePicker } from "@albelli/photoselector"
import { MyDevice } from "@albelli/photoselector-mydevice-onlineuploader"
import { PhotoOrganiser } from "@albelli/photoselector-photoorganizer"
import Config from '../../config'

const PhotoSelector = (props) => {

  return (
      <AppImagePicker 
        language={sessionStorage.getItem("language") == "fr-BE" ? "fr-FR" : sessionStorage.getItem("language")} // photoselecor does not work with fr-BE, so need to use fr-FR
        completeOnSelect={false} 
        shouldSort={false} 
        range={Config.photoSelector.range} 
        onSelectedItems={props.onSelectedItems} 
        showSelection={true}
      >
        {({ locale }) => (
              <PhotoOrganiser queryApi={Config.photoSelector.photoOrganiserQueryApiUrl} authenticator={Config.photoSelector.photoOrganiserAuthenticator}>
                {locale.photoorganiser.empty(Config.photoOrganiserVendorNames[sessionStorage.getItem("vendor")])}
              </PhotoOrganiser>           
        )}
 
      </AppImagePicker>        
  )
}

export default PhotoSelector